// /opt/isp_erp/frontend/src/components/warehouse/CabeceraBodega.jsx
import React from "react";
import { Box, Typography } from "@mui/material";

/** Cabecera común de las pantallas de Bodega: título, descripción y (opcional) acciones a la derecha. */
export default function CabeceraBodega({ titulo, subtitulo, children, colores = ["#1e3a8a", "#2563eb", "#38bdf8"] }) {
  return (
    <Box sx={{ position: "relative", overflow: "hidden", borderRadius: 4, p: { xs: 2.5, md: 3 }, mb: 3, color: "#fff",
               background: `linear-gradient(135deg, ${colores[0]} 0%, ${colores[1]} 55%, ${colores[2]} 100%)` }}>
      <Box sx={{ position: "absolute", right: -40, top: -50, width: 180, height: 180, borderRadius: "50%", bgcolor: "rgba(255,255,255,0.10)" }} />
      <Box sx={{ position: "relative", display: "flex", justifyContent: "space-between", alignItems: "center", gap: 2, flexWrap: "wrap" }}>
        <Box>
          <Typography variant="overline" sx={{ opacity: 0.85, letterSpacing: 2 }}>Bodega</Typography>
          <Typography variant="h4" sx={{ fontWeight: 800, lineHeight: 1.1 }}>{titulo}</Typography>
          {subtitulo && <Typography sx={{ opacity: 0.92, mt: 0.75, maxWidth: 720 }}>{subtitulo}</Typography>}
        </Box>
        {children && <Box sx={{ display: "flex", gap: 1, alignItems: "center", flexWrap: "wrap" }}>{children}</Box>}
      </Box>
    </Box>
  );
}
